// extracted by mini-css-extract-plugin
module.exports = {"container":"Temperaments_container__1eMMC","grid":"Temperaments_grid__Okv8X","li":"Temperaments_li__NSn_9"};